import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22Zm8.747-10.778a7.189 7.189 0 0 0 1.663-1.273c.736-.741 1.16-1.209 1.549-1.754l.081-.096.056-.064c.441-.511.623-.811.657-1.298.057-.79-.354-1.392-1.177-2.155-.563-.523-1.23-.957-2.027-1.348a41.023 41.023 0 0 0-.509-.248c-.568-.27-1.019-.444-1.475-.545-.78-.174-1.474-.093-2.058.322-.248.176-.43.359-.744.716l-.081.093a7.662 7.662 0 0 1-.218.24c-.437.456-.868.8-1.324 1.044-2.155 1.148-5.11.673-6.94-1.072-1.058-1.109-1.691-2.727-1.654-4.273.03-1.243.441-2.46 1.163-3.419.203-.269.399-.482.824-.915l.045-.047.235-.24c.492-.513.739-1.066.734-1.744-.005-.638-.157-1.12-.56-2.047l-.046-.106-.044-.102c-.363-.842-.668-1.423-1.063-1.958-.547-.74-1.11-1.27-1.762-1.541a1.718 1.718 0 0 0-1.185-.072c-.332.104-.538.249-.929.59l-.016.014c-.071.062-.11.094-.151.129-1.627 1.245-2.66 2.345-3.269 3.717-.993 2.238-.784 4.876.33 7.631 1.014 2.51 2.703 4.906 4.821 6.94a22.242 22.242 0 0 0 4.007 3.28c2.078 1.338 4.22 2.195 6.32 2.434 1.709.194 3.356-.074 4.747-.833Z",
    fill: "currentColor"
  }));
};

var SvgCallCircle = styled(SvgComponent).withConfig({
  displayName: "CallCircle__SvgCallCircle",
  componentId: "sc-lxl82a-0"
})(["", " ", ""], size, color);
export default SvgCallCircle;